import { useQuery } from "@tanstack/react-query";
import { getUsersHunterDetailHunterUserID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const HUNTER_DETAIL_QUERY_KEY = "HUNTER_DETAIL";

export const hunterDetailKeys = {
  all: [HUNTER_DETAIL_QUERY_KEY],
  byUserID: (userID: number) => [...hunterDetailKeys.all, userID],
};

export const useHunterDetailQuery = (hunterUserID: number) =>
  useQuery({
    queryKey: hunterDetailKeys.byUserID(hunterUserID),
    queryFn: processResponseWithApiProblemDetails(() =>
      getUsersHunterDetailHunterUserID(hunterUserID),
    ),
    enabled: !!hunterUserID,
    refetchOnWindowFocus: false,
  });
